module.exports = __webpack_public_path__ + "9b87f5e71de2a4f99218ce0d4c33910a.png";